import {Option} from '../../shared/models/option';
import {getFriendlyTimeZoneString, HUB_TIMEZONES} from '../models/hub';

/**
 * Tile History Constants
 *
 * This file contains configuration constants for the tile history feature.
 * For types and interfaces, see: src/shared/models/time-range.ts
 */

// Time constants (milliseconds)
export const TWO_MONTHS_MS = 60 * 24 * 60 * 60 * 1000; // 60 days
export const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

// History fetch quantity
export const HISTORY_QUANTITY = 200;

// Interval options for SIMPLE_ANALOG tiles
export const INTERVAL_OPTIONS_ANALOG: Option[] = [
  {id: 'none', name: 'Every Recorded Value'},
  {id: '5m', name: 'First Value Stored Every 5 Minutes'},
  {id: '15m', name: 'First Value Stored Every 15 Minutes'},
  {id: '30m', name: 'First Value Stored Every ½ Hour'},
  {id: '1h', name: 'First Value Stored Every Hour'},
  {id: '4h', name: 'First Value Stored Every 4 Hours'},
];

export const INTERVAL_OPTIONS_ANALOG_DEFAULT = 'none';

// PLAT-243: Interval options for SIMPLE_BOOL and SIMPLE_MULTISTATE tiles
// Only "Every Recorded Value" is allowed for these tile types
export const INTERVAL_OPTIONS_BOOL_MULTISTATE: Option[] = [
  {id: 'none', name: 'Every Recorded Value'},
];

export const INTERVAL_OPTIONS_BOOL_MULTISTATE_DEFAULT = 'none';

export type TimezoneOption = {iana: string; label: string};

const INTERNATIONAL_TIMEZONES: TimezoneOption[] = [
  {iana: 'America/Halifax',    label: 'Canada Atlantic: America/Halifax'},
  {iana: 'America/Sao_Paulo',  label: 'Brazil: America/Sao_Paulo'},
  {iana: 'UTC',                label: 'UTC'},
  {iana: 'Europe/London',      label: 'UK: Europe/London'},
  {iana: 'Europe/Paris',       label: 'Central Europe: Europe/Paris'},
  {iana: 'Europe/Helsinki',    label: 'Eastern Europe: Europe/Helsinki'},
  {iana: 'Africa/Cairo',       label: 'Egypt: Africa/Cairo'},
  {iana: 'Africa/Nairobi',     label: 'East Africa: Africa/Nairobi'},
  {iana: 'Asia/Dubai',         label: 'Gulf: Asia/Dubai'},
  {iana: 'Asia/Kolkata',       label: 'India: Asia/Kolkata'},
  {iana: 'Asia/Bangkok',       label: 'Southeast Asia: Asia/Bangkok'},
  {iana: 'Asia/Shanghai',      label: 'China: Asia/Shanghai'},
  {iana: 'Asia/Singapore',     label: 'Singapore: Asia/Singapore'},
  {iana: 'Asia/Tokyo',         label: 'Japan: Asia/Tokyo'},
  {iana: 'Australia/Sydney',   label: 'Australia Eastern: Australia/Sydney'},
  {iana: 'Pacific/Auckland',   label: 'New Zealand: Pacific/Auckland'},
];

export const HISTORY_TIMEZONE_OPTIONS: TimezoneOption[] = [
  ...HUB_TIMEZONES.map(iana => ({iana, label: getFriendlyTimeZoneString(iana)})),
  ...INTERNATIONAL_TIMEZONES,
];
